import React, { FunctionComponent, useState } from "react";
import { ButtonProps, CommandBarButton, ConfirmDialog, useDisclosure, useNotifications } from "sprint-common-web";

import { useAdminEncodeCachingApi } from "./useAdminEncodeCachingApi";

export type PurgeEncodeCacheButtonProps = ButtonProps & {
    onSuccess?: () => void;
};

export const PurgeEncodeCacheButton: FunctionComponent<PurgeEncodeCacheButtonProps> = ({
    disabled,
    onSuccess
}: PurgeEncodeCacheButtonProps) => {
    const { isOpen, onClose, onOpen } = useDisclosure();
    const [isBusy, setIsBusy] = useState<boolean>(false);
    const { purge } = useAdminEncodeCachingApi();
    const { success, error } = useNotifications();

    const purgeCache = async () => {
        setIsBusy(true);

        await purge()
            .then(() => {
                success("Cache removed successfully");
                if (onSuccess) onSuccess();
            })
            .catch(() => {
                error("Error while purging cache");
            })
            .finally(() => {
                setIsBusy(false);
                onClose();
            });
    };

    return (
        <>
            <CommandBarButton onClick={onOpen} text="Purge" icon="Delete" />

            <ConfirmDialog
                title="Encode cache purge"
                text="Are you sure you want to remove all cache entries? This action is irreversible."
                hidden={!isOpen}
                confirm={{ onClick: purgeCache, disabled: isBusy }}
                cancel={{ onClick: onClose }}
            />
        </>
    );
};
